const TABS = [
  { key: 'home', icon: '🏠', label: 'ホーム' },
  { key: 'templates', icon: '🗂️', label: 'テンプレート' },
];

/** Bottom tab bar switching between the Home / Templates / Settings screens. */
export default function BottomNavigation({ activeTab, onChange }) {
  return (
    <nav className="bottom-nav">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`nav-item${activeTab === tab.key ? ' active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          <div className="nav-icon">{tab.icon}</div>
          <div className="nav-text">{tab.label}</div>
        </button>
      ))}
    </nav>
  );
}
